import { BotPublicInfo } from '@types'
import axiosBaseApi from '../axiosBaseApi'

/**
 * Fetches the status of a bot by its primary ID from the bot table.
 *
 * @param id - The primary ID of the bot.
 */
export const getBotStatus = async (id: number) => {
	try {
		return await axiosBaseApi.get(`/bots/${id}/status`)
	} catch (error) {
		console.error('Error fetching bot data:', error)
	}
}

/**
 * Fetches the status of a bot by its primary ID from the bot table.
 *
 * @param id - The primary ID of the bot.
 */
export const getBotInfo = async (
  id: number,
): Promise<{ bot: BotPublicInfo } | undefined> => {
  try {
    return await axiosBaseApi.get(`/bots/${id}`)
  } catch (error) {
    console.error('Error get bot info:', error)
  }
}

/**
 * Fetch the availability histograms for a bot.
 *
 * @param id - The primary ID of the bot.
 */
export const getBotAvailability = async (
  id: number,
): Promise<{ availability: number[] } | undefined> => {
  try {
    return await axiosBaseApi.get(`/bots/${id}/availability?timezone_offset=${new Date().getTimezoneOffset()}`)
  } catch (error) {
    console.error('Error fetching bot availability:', error)
  }
}